import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('CoBrandingBannerMobile', () => {
      return import(
        './viewer/CoBrandingBannerMobile' /* webpackChunkName: "CoBrandingBannerMobile" */
      ).then(componentModule => {
        return {
          component: componentModule.default,
        };
      });
    });
  },
};

export default entry;
